import { render, staticRenderFns } from "./GetSlide.vue?vue&type=template&id=7c42e9b9&scoped=true&"
import script from "./GetSlide.vue?vue&type=script&lang=js&"
export * from "./GetSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c42e9b9",
  null
  
)

export default component.exports